module.exports = __webpack_public_path__ + "static/media/galdinsLose_250_500.9a9b70e3.png";